import React, { useEffect } from 'react';
import "./layouts.css";
import { Outlet, useLocation, useNavigate } from 'react-router';
import SideNav from '../nav/SideNav';
import TopBar from '../nav/TopBar';

const AgentLayout = () => {

  const navigate = useNavigate();

  // const [isAgent, setIsAgent] = useState(false);
  const pathname = useLocation().pathname;

  const checkActiveUser = () => {
    const user = JSON.parse(localStorage.getItem("apk"));
    if (user) {
      if(user?.data?.accountType === "Developer"){
        navigate("/dev_dash/dashboard")
      }
    }
    if(!user?.data?.accountType && user?.data?.accountType !== "Agent"){
      navigate("/auth/signin")
    } 
    // console.log(user);
  }

  useEffect(() => {
    checkActiveUser();
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    // eslint-disable-next-line
  }, [pathname])

  return (
    <div className='agent-layout'>
        <div className="agent-layout_left">
            <SideNav />
        </div>
        <div className="agent-layout_right">
            <TopBar />
            <Outlet />  
        </div>
    </div>
  )
}

export default AgentLayout